import React from 'react';

import Widget from '../UI/widget';
import YearMonthSelection from '../UI/yearMonthSelection';
import TotalsCard from './totalsCard';
import CardsList from './cardsList';

import './calendarView.style.css';

const calendarView = ({
    currency,
    selectedMonth,
    selectedYear,
    dateChanged,
    totals,
    cards,
    showForecast,
    cardsProps,
    period,
}) => (
    <>
        <YearMonthSelection month={selectedMonth} year={selectedYear} period={period} dateChanged={dateChanged} />
        <div className="CalendarViewContainer">
            <div className="CalendarViewContentWrapper">
                <div className="CalendarViewTotalsWrapper">
                    <div className="CalendarViewTotals">
                        <Widget title="Performance">
                            <TotalsCard {...totals} showForecast={showForecast} currency={currency} />
                        </Widget>
                        <br />
                    </div>
                </div>
                <div className="CalendarViewBody">
                    <CardsList cards={cards} currency={currency} {...cardsProps} showForecast={showForecast} />
                </div>
            </div>
        </div>
    </>
);

export default calendarView;
